module.exports = __webpack_public_path__ + "img/arow-down.5a72f1f2.svg";